class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.details = this.querySelector('details');
    this.addEventListener('mouseenter', this.toggleOpen.bind(this))
    this.addEventListener('mouseleave', this.toggleClose.bind(this));
    document.addEventListener('shopify:section:load', ()=> {
      this.header = document.querySelector('.header-wrapper');
    });
  }

  toggleOpen(e) {
    this.details.setAttribute('open', true);
    this.details.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  toggleClose(e) {
    this.close();
    this.onToggle();
  }

  onToggle() {
    if (HeaderMenu._measuring) return;
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // if (this.details.open) {
    //   this.header.classList.add('is-megamenu-open')
    // } else {
    //   this.header.classList.remove('is-megamenu-open')
    // }

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop',
      ) !== ''
    )
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);

(function equalizeMegaMenuHeights() {
  let resizeTimer;

  function measure() {
    const megaMenus = document.querySelectorAll('.header__inline-menu details.mega-menu');
    if (megaMenus.length < 2) return;

    document.documentElement.style.removeProperty('--mega-menu-min-height');

    HeaderMenu._measuring = true;

    megaMenus.forEach((menu) => menu.classList.add('mega-menu--measuring'));
    void document.body.offsetHeight;

    megaMenus.forEach((menu) => menu.setAttribute('open', ''));
    void document.body.offsetHeight;

    let maxHeight = 0;
    megaMenus.forEach((menu) => {
      const content = menu.querySelector('.mega-menu__content');
      if (content) {
        maxHeight = Math.max(maxHeight, content.scrollHeight);
      }
    });

    megaMenus.forEach((menu) => menu.removeAttribute('open'));
    megaMenus.forEach((menu) => menu.classList.remove('mega-menu--measuring'));

    HeaderMenu._measuring = false;

    if (maxHeight > 0) {
      document.documentElement.style.setProperty(
        '--mega-menu-min-height',
        maxHeight + 'px',
      );
    }
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measure, 200);
  }

  measure();
  window.addEventListener('resize', onResize);
})();
